import { ca } from '@cian/analytics';

export function trackSaveDistrictsEvent(label: number) {
  ca('event', {
    name: 'oldevent',
    category: 'Listing',
    action: 'popup_district_save',
    label,
  });
}
